// eslint-disable-next-line jira/restricted/react-suspense, jira/restricted/react-lazy
import React, { lazy, Suspense } from 'react';
import type { Props } from './types';

// @ts-expect-error - TS2344 - Type 'Props' does not satisfy the constraint 'ComponentType<any>'.
const AddScreenModal = lazy<Props>(
	() => import(/* webpackChunkName: "async-add-screen-modal" */ './index'),
);

export const AsyncAddScreenModal = (props: Props) =>
	__SERVER__ ? null : (
		<Suspense fallback={null}>
			{/* @ts-expect-error - TS2559 - Type '{ isModalOpen: boolean; onClose: () => void; }' has no properties in common with type 'IntrinsicAttributes'. */}
			<AddScreenModal {...props} />
		</Suspense>
	);
